import { Component} from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { ThisTypeNode } from 'typescript';
import { BottomSheet } from '../bottom.sheet';
import { timeEnd } from 'console';

@Component({
  selector: 'app-createitem',
  templateUrl: './createitem.component.html',
  styleUrls: ['./createitem.component.scss'],
})
export class CreateitemComponent  {
itemname;
upc;
sku;
purchasecategory;
aqty;
sqty;
mrp;
sprice;
hsn;
daysToDeliver;
serviceTypeName;
colorObj;
colorName;
colorId;
sizeObj;
sizeName;
sizeId;
serviceId;
promotionName;
promoId;
productName;
productId;
brandName;
brand;
productObj:any;
brandObj:any;
brandCode;
promotions;
pic;
loader:boolean;
id;
product:any;
editBool:boolean;
category;
cateName;
cateId;

  constructor( protected sanitizer: DomSanitizer,private router: Router, private bottomSheet: MatBottomSheet,  public handler: HandlerService,
    public service: ApiService,) { }
  
  ionViewWillEnter(){

    let url = window.location.href;
    this.id = window.location.href.split('/').pop();
    if (url.includes('edit-item')) {
      this.editBool=true;
      this.loader = true; 
      this.service.getItemProductById(this.id).subscribe((res:any)=>{
      this.product = res;
      this.loader = false;
      this.itemname = res.name;
      this.sku=res.sku;
      this.cateId = res.purchaseCategory;
      this.sqty=res.stockOutQty;
      this.mrp=res.markedPrice;
      this.sprice=res.priceToFranchise;
      this.hsn=res.hsn;
      this.daysToDeliver=res.daysToDeliver;
      this.pic=res.img;
      this.productId=res.productId;
      this.colorId=res.colorId;
      this.sizeId=res.sizeId;
      this.brand=res.brand;
      })
      }
      else{
        
        this.editBool = false;
      } 
      this.getCategory(); 
      this.getProductObject();
      this.getBrand();
      this.getAllColor();
      this.getAllSize();
      this.getPromotions(); 
  }
  getProductObject(){
    this.service.getAllProduct().subscribe(res => {
      this.productObj = res;
        this.productObj.map(dat=>{
          if(dat.id==this.productId){
           this.productName = dat.name
          }
        }) 
       
  
    })
  }

    openBottomSheetProduct() {
      this.productObj=this.productObj.filter(res=>{return this.cateId==res.purchaseCategory})
      const dialogRef = this.bottomSheet.open(BottomSheet, {
        data: this.productObj,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        if (res) {
          this.productName = res.name;
          this.productId = res.id;
        }
      });
    }

    getBrand(){
      this.service.getAllbrand().subscribe(res => {
        this.brandObj = res;
          this.brandObj.map(dat=>{
            if(dat.id==this.brand){
             this.brandName = dat.name
            }
          }) 
         
       })
    }

    openBottomSheetBrand() {
      this.brandObj=this.brandObj.filter(res=>{return this.cateId==res.purchaseCategory})
      const dialogRef = this.bottomSheet.open(BottomSheet, {
        data: this.brandObj,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.brandName = res.name;
        this.brand = res.id;
        this.brandCode = res.code;
      }
    });
  }
  getPromotions(){
    this.service.getItemPromotions().subscribe(res => {
      this.promotions = res;   
        this.promotions.map(dat=>{
          if(dat.id==this.promoId){
            this.promotionName=dat.name
          }
        })
    })
  }
  openBottomSheetPromotion() {
      const dialogRef = this.bottomSheet.open(BottomSheet, {
        data: this.promotions,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        if (res) {
          this.promotionName = res.name;
          this.promoId = res.id;
        }
      });
    
  }
  handleFile(files) {
    if (files[0].size < 1048576) {
      var img = new Image();
      img.src = URL.createObjectURL(files[0]);
      img.onload = (data) => {
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        this.pic = canvas.toDataURL('image/jpeg', 1.5);
      }
    }
    else {
      this.handler.res('Image Size Should Not Exceeds 1mb ');
    }
}
create(){
  this.loader=true;
  let post;
  post={
      "name": this.itemname,
      "price":this.mrp ,
      "priceToFranchise": this.sprice,
      "sku": this.sku,
      "stockOutQty": this.sqty,
      "img": this.pic,
      "productId": this.productId,
      "colorId":this.colorId,
      "sizeId":this.sizeId,
      "brand":this.brand,
      "markedPrice":this.mrp,
      "promotionId": this.promoId,
      "hsn": this.hsn,
      "daysToDeliver": this.daysToDeliver,
      "purchaseCategory":this.cateId,
      "type":2
      }
  this.service.createItemProduct(post).subscribe(dat=>{
    this.handler.res("Item Created Successfully");
    this.loader = false;
    this.router.navigate(['manage-items'])
  }) 
  }
  update(){
    this.loader = true;
    this.product.name = this.itemname;
    this.product.price = this.mrp;
    this.product.priceToFranchise = this.sprice;
    this.product.sku = this.sku;
    this.product.purchaseCategory = this.cateId;
    this.product.colorId = this.colorId;
    this.product.sizeId = this.sizeId;
    if(this.hsn)
      this.product.hsn=this.hsn;
      if(this.promoId)
        this.product.promotionName=this.promoId;
        this.product.daysToDeliver=this.daysToDeliver;
        this.product.stockOutQty=this.sqty;
        this.product.img=this.pic;
        this.product.productId=this.productId;
        this.product.markedprice=this.mrp;
        this.product.promotionId=this.promoId;
        this.service.updateItemProduct(this.id,this.product).subscribe(res=>{
          this.handler.res("Item Updated Successfully");
          this.loader = false;
           this.router.navigate(['manage-items'])
        },err=>{
          this.handler.err(err);
          this.loader = false;
        })        
  }
  openBottomSheetPurchase(){
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.category,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.cateName = res.name;
        this.cateId = res.id;  
        }
    });
  }

  getCategory(){
    this.service.getAllPurchaseCategory().subscribe((res:any)=>{
      this.category=res;
      this.category.map(dat=>{
        if(dat.id==this.cateId){
          this.cateName = dat.name;
        }
      })
      this.loader=false;
    })
  }

  getAllSize(){
    this.service.getAllsize().subscribe(res=>{
      if(res){
        this.sizeObj = res;
          this.sizeObj.map(dat=>{
            if(dat.id==this.sizeId){
             this.sizeName = dat.name
            }
          }) 
      
      }
    })
  }

  openBottomSheetSize() {
    this.productObj=this.productObj.filter(res=>{return this.cateId==res.purchaseCategoryId && this.productId==res.productId})
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.sizeObj,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.sizeName = res.name;
        this.sizeId = res.id;
      }
    });
  }

  getAllColor(){
    this.service.getAllcolor().subscribe(res=>{
      if(res){
        this.colorObj = res;
          this.colorObj.map(dat=>{
            if(dat.id==this.colorId){
             this.colorName = dat.name
            }
          }) 
         }  
    })
  }

  openBottomSheetColor() {
    this.productObj=this.productObj.filter(res=>{return this.cateId==res.purchaseCategoryId && this.productId==res.productId})
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.colorObj,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.colorName = res.name;
        this.colorId = res.id;
      }
    });
  }
}

  